export class DevExtremeHelper {
  public static get formatAxisValue() {
    return {
      type: 'fixedPoint', // the format of absolute values
      precision: 1, // the precision of absolute values (123.456 --> 123.4)
      percentPrecision: 2, // the precision of percentage values (12.3456 % --> 12.34 %)
    };
  }

  public static get formatAxisValueInteger() {
    return {
      type: 'fixedPoint',
      precision: 0,
      percentPrecision: 0,
    };
  }
}
